import { fetchMapLocations, selectMapStatus, selectPlaces } from 'containers/Maps/Map/mapSlice'
import NewPlaceElementForList from 'containers/Maps/Result/NewPlaceElementForList'
import SkeletonElement from 'containers/Maps/Result/SkeletonElement'
import { Swiper, SwiperSlide, type SwiperRef } from 'swiper/react'
import { useReduxDispatch, useReduxSelector } from 'store'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import React, { useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { Autoplay } from 'swiper/modules'
import { STATUS } from 'utils/constants'
import Error from 'components/Error'

const Carousel: React.FC = () => {
  const placesStatus = useReduxSelector(selectMapStatus)
  const places = useReduxSelector(selectPlaces)
  const swiper = useRef<SwiperRef>(null)

  const { push } = useHistory()
  const { t } = useTranslation('onePage')
  const dispatch = useReduxDispatch()
  useEffect(() => {
    if (placesStatus !== STATUS.pending) {
      dispatch(fetchMapLocations())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  return (
    <div className='onePage__carousel'>
      <h3>{t('recentlyJoinedUs')}</h3>
      <h1>{t('storageFacilities')}</h1>

      <div className='onePage__carousel__main'>
        <Swiper
          ref={swiper}
          grabCursor
          speed={1000}
          centeredSlides
          slideToClickedSlide
          touchMoveStopPropagation
          modules={[Autoplay]}
          preventClicks={true}
          slidesPerView='auto'
          autoplay={{ delay: 5000 }}
          loop={places.length > 10}>
          {places && places.length > 0
            ? (places as any[]).map((place) => <SwiperSlide
              key={place.id}
              className='place__slide'>
              <NewPlaceElementForList
                data={place}
                key={place.id}
                customRedirect={`/map/${place.id}`}
                navigate={(path: string) => {
                  window.scrollTo(0, 0)
                  push('/map')
                  push(path)
                }}
              />
            </SwiperSlide>)
            : placesStatus !== STATUS.succeed
              ? [1, 2].map((index) => <SwiperSlide
                key={index}
                className='place__slide'>
                <SkeletonElement
                  isDesktop
                  key={index}
                />
              </SwiperSlide>)
              : <SwiperSlide className='place__slide'>
                <Error staticPos text={t('thereIsALackOfYards')} />
              </SwiperSlide>}
        </Swiper>
      </div>

      {places && places.length > 0 && <div className='onePage__carousel__footer'>
        <button
          type='button'
          title={t('prev')}
          className='btn-gray'
          onClick={() => {
            swiper.current?.swiper?.slidePrev()
          }}>
          <i className='icon icon--arrow-left-hide' />
        </button>
        <ArrowBtn
          enlarged
          showArrow={false}
          text={t('seeEntireMap')}
          action={() => {
            push('/map')
          }}
        />
        <button
          type='button'
          title={t('next')}
          className='btn-gray'
          onClick={() => {
            swiper.current?.swiper?.slideNext()
          }}>
          <i className='icon icon--arrow-right-hide' />
        </button>
      </div>}
    </div>
  )
}

export default Carousel